import Axios from 'axios'
import { ApiConstants } from 'constants/ApiConstants'

export function submitContactData(data) {
	return Axios.post(ApiConstants.BASE_URL + 'contact-us', data)
}
